"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
require("./styles/damaged.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
/**
 * @ngdoc module
 * @module rinca.apps.damaged
 * @name rinca.apps.damaged
 * @packageName rinca.apps
 * @description A module that includes the damaged component.
 */
angular.module('rinca.apps.damaged', ['ui.router'])
    .controller('DamagedController', controllers_1.DamagedController)
    .service('_damaged', services_1.DamagedService)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/damaged/index.ts
// module id = 384
// module chunks = 0